const defaultSetFilterParams = {
    buttons: ['clear'],
    debounceMs: 1000,
};
export default defaultSetFilterParams;
